export default __webpack_public_path__ + "static/8-fec1cfdbfb44f6ec7196996c4c57acd3.jpg";